import payload_plugin_qLmFnukI99 from "/app/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_PSbK9A48ZQ from "/app/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import plugin_ghbUAjaD3n from "/app/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_L93bAIrZuZ from "/app/modules/auth/runtime/plugin.ts";
import index_kyvreQaQna from "/app/plugins/vuetify/index.ts";
import index_pJsEXjjc09 from "/app/plugins/iconify/index.ts";
import JsonEditorVue_client_ougvixbluy from "/app/plugins/JsonEditorVue.client.ts";
import googleLogin_client_6mRoedxQOA from "/app/plugins/googleLogin.client.ts";
import qrcode_client_k7ZrmM9P2F from "/app/plugins/qrcode.client.ts";
import toast_client_9z8IIRO0Dx from "/app/plugins/toast.client.ts";
import webfontloader_client_iX85i8j6U3 from "/app/plugins/webfontloader.client.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_PSbK9A48ZQ,
  plugin_ghbUAjaD3n,
  plugin_L93bAIrZuZ,
  index_kyvreQaQna,
  index_pJsEXjjc09,
  JsonEditorVue_client_ougvixbluy,
  googleLogin_client_6mRoedxQOA,
  qrcode_client_k7ZrmM9P2F,
  toast_client_9z8IIRO0Dx,
  webfontloader_client_iX85i8j6U3
]